module.exports = __webpack_public_path__ + "img/banner4.c6a4baae.png";